/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV0ConfigurationAliveGet$Json } from '../fn/configuration/api-v-0-configuration-alive-get-json';
import { ApiV0ConfigurationAliveGet$Json$Params } from '../fn/configuration/api-v-0-configuration-alive-get-json';
import { apiV0ConfigurationAliveGet$Plain } from '../fn/configuration/api-v-0-configuration-alive-get-plain';
import { ApiV0ConfigurationAliveGet$Plain$Params } from '../fn/configuration/api-v-0-configuration-alive-get-plain';
import { apiV0ConfigurationErrorPost } from '../fn/configuration/api-v-0-configuration-error-post';
import { ApiV0ConfigurationErrorPost$Params } from '../fn/configuration/api-v-0-configuration-error-post';
import { apiV0ConfigurationMotdGet$Json } from '../fn/configuration/api-v-0-configuration-motd-get-json';
import { ApiV0ConfigurationMotdGet$Json$Params } from '../fn/configuration/api-v-0-configuration-motd-get-json';
import { apiV0ConfigurationMotdGet$Plain } from '../fn/configuration/api-v-0-configuration-motd-get-plain';
import { ApiV0ConfigurationMotdGet$Plain$Params } from '../fn/configuration/api-v-0-configuration-motd-get-plain';
import { apiV0ConfigurationVersionGet$Json } from '../fn/configuration/api-v-0-configuration-version-get-json';
import { ApiV0ConfigurationVersionGet$Json$Params } from '../fn/configuration/api-v-0-configuration-version-get-json';
import { apiV0ConfigurationVersionGet$Plain } from '../fn/configuration/api-v-0-configuration-version-get-plain';
import { ApiV0ConfigurationVersionGet$Plain$Params } from '../fn/configuration/api-v-0-configuration-version-get-plain';
import { apiV0ConfigurationVersionInfoGet$Json } from '../fn/configuration/api-v-0-configuration-version-info-get-json';
import { ApiV0ConfigurationVersionInfoGet$Json$Params } from '../fn/configuration/api-v-0-configuration-version-info-get-json';
import { apiV0ConfigurationVersionInfoGet$Plain } from '../fn/configuration/api-v-0-configuration-version-info-get-plain';
import { ApiV0ConfigurationVersionInfoGet$Plain$Params } from '../fn/configuration/api-v-0-configuration-version-info-get-plain';
import { VersionInfo } from '../models/version-info';

@Injectable({ providedIn: 'root' })
export class ConfigurationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV0ConfigurationAliveGet()` */
  static readonly ApiV0ConfigurationAliveGetPath = '/api/v0/configuration/alive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConfigurationAliveGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationAliveGet$Plain$Response(params?: ApiV0ConfigurationAliveGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0ConfigurationAliveGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConfigurationAliveGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationAliveGet$Plain(params?: ApiV0ConfigurationAliveGet$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0ConfigurationAliveGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConfigurationAliveGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationAliveGet$Json$Response(params?: ApiV0ConfigurationAliveGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0ConfigurationAliveGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConfigurationAliveGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationAliveGet$Json(params?: ApiV0ConfigurationAliveGet$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0ConfigurationAliveGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiV0ConfigurationVersionGet()` */
  static readonly ApiV0ConfigurationVersionGetPath = '/api/v0/configuration/version';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConfigurationVersionGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationVersionGet$Plain$Response(params?: ApiV0ConfigurationVersionGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    const obs = apiV0ConfigurationVersionGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConfigurationVersionGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationVersionGet$Plain(params?: ApiV0ConfigurationVersionGet$Plain$Params, context?: HttpContext): Observable<number> {
    const resp = this.apiV0ConfigurationVersionGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConfigurationVersionGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationVersionGet$Json$Response(params?: ApiV0ConfigurationVersionGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    const obs = apiV0ConfigurationVersionGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConfigurationVersionGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationVersionGet$Json(params?: ApiV0ConfigurationVersionGet$Json$Params, context?: HttpContext): Observable<number> {
    const resp = this.apiV0ConfigurationVersionGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `apiV0ConfigurationVersionInfoGet()` */
  static readonly ApiV0ConfigurationVersionInfoGetPath = '/api/v0/configuration/versionInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConfigurationVersionInfoGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationVersionInfoGet$Plain$Response(params?: ApiV0ConfigurationVersionInfoGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<VersionInfo>> {
    const obs = apiV0ConfigurationVersionInfoGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConfigurationVersionInfoGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationVersionInfoGet$Plain(params?: ApiV0ConfigurationVersionInfoGet$Plain$Params, context?: HttpContext): Observable<VersionInfo> {
    const resp = this.apiV0ConfigurationVersionInfoGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VersionInfo>): VersionInfo => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConfigurationVersionInfoGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationVersionInfoGet$Json$Response(params?: ApiV0ConfigurationVersionInfoGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<VersionInfo>> {
    const obs = apiV0ConfigurationVersionInfoGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConfigurationVersionInfoGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationVersionInfoGet$Json(params?: ApiV0ConfigurationVersionInfoGet$Json$Params, context?: HttpContext): Observable<VersionInfo> {
    const resp = this.apiV0ConfigurationVersionInfoGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VersionInfo>): VersionInfo => r.body)
    );
  }

  /** Path part for operation `apiV0ConfigurationMotdGet()` */
  static readonly ApiV0ConfigurationMotdGetPath = '/api/v0/configuration/motd';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConfigurationMotdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationMotdGet$Plain$Response(params?: ApiV0ConfigurationMotdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0ConfigurationMotdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConfigurationMotdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationMotdGet$Plain(params?: ApiV0ConfigurationMotdGet$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0ConfigurationMotdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConfigurationMotdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationMotdGet$Json$Response(params?: ApiV0ConfigurationMotdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = apiV0ConfigurationMotdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConfigurationMotdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV0ConfigurationMotdGet$Json(params?: ApiV0ConfigurationMotdGet$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.apiV0ConfigurationMotdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiV0ConfigurationErrorPost()` */
  static readonly ApiV0ConfigurationErrorPostPath = '/api/v0/configuration/error';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV0ConfigurationErrorPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConfigurationErrorPost$Response(params?: ApiV0ConfigurationErrorPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = apiV0ConfigurationErrorPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV0ConfigurationErrorPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV0ConfigurationErrorPost(params?: ApiV0ConfigurationErrorPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiV0ConfigurationErrorPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
